





































import {Component, Prop, Watch, Mixins, Vue} from 'vue-property-decorator'
import {$} from 'simpli-web-sdk'
import {snakeCase} from 'lodash'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import CargaCollection from '@/model/collection/CargaCollection'
import FilterDeliveryChecklist from '@/components/filters/FilterDeliveryChecklist.vue'
import {AppConfig} from '@/config/app.config'
import * as Helper from '@/helpers'
import Carga from '@/model/resource/Carga'
import DeliveryRequestChecklist from '@/model/request/DeliveryChecklistRequest'
import FilterToggle from '@/components/FilterToggle.vue'
import moment from 'moment'

const metaInfo = () => ({
    title: $.t('view.reports.deliveryChecklist.title'),
})

@Component({
    metaInfo,
    components: {FilterToggle, FilterDeliveryChecklist},
})
export default class ReportsDeliveryChecklist extends Mixins(MixinFilter) {
    AppConfig = AppConfig

    filter = new DeliveryRequestChecklist()
    collection = new CargaCollection(this.filter)

    async created() {
        this.filter.startDate = moment().format()
        this.collection.endpoint = '/user/carga/checklist'
    }

    async downloadData(xlsx = false) {
        const title = this.$t('view.reports.deliveryChecklist.title') as string

        if (!xlsx) {
            await $.await.run(() => Helper.downloadCsv(title, '/user/carga/checklist/csv', this.filter,
                true, Helper.getTypeReportChecklist()),
                'download')
        } else {
            await $.await.run(() => Helper.downloadXlsx(
                title,
                '/user/carga/checklist/csv',
                this.filter,
                Carga,
                'Carga',
                true,
                Helper.getTypeReportChecklist(),
            ), 'download')
        }
    }
}
